;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import React from 'react';
import { useCookies } from 'shared/contexts/CookiesContext';
import GoogleTagManagerTrackingCode from './gTagTracking';
import HotjarTrackingCode from './hotjarTracking';

const prod = process.env.NODE_ENV_SYNERGIE_ENV && process.env.NODE_ENV_SYNERGIE_ENV === 'production';
const dev = process.env.NODE_ENV === 'development';

function Tracking() {
  const { enabledCookies } = useCookies();
  if (!enabledCookies.tracking || dev) return null;

  return (
    <>
      <GoogleTagManagerTrackingCode />
      {prod && <HotjarTrackingCode />}
    </>
  );
}

export default Tracking;
